module.exports = __webpack_public_path__ + "media/pdfs/Prepworks-Academy_Curriculum-and-Package-Information-ac673ba585b0175a0904e9217dec2e8f.pdf";